import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
const mode = process.env.REACT_APP_MODE;
if (mode === 'stg') {
  Sentry.init({
    dsn: 'https://f493f79457eb36e16dbcea60b8972814@o1090422.ingest.sentry.io/4506551603298304',
    integrations: [new Sentry.BrowserTracing()],
    // 詳細なコントロールはここに記載
    tracesSampleRate: 1.0,
    // 全セッションの10%にキャプチャー・リプレイを提供
    // エラーが発生したセッションの100
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
} else if (mode === 'prd') {
  Sentry.init({
    dsn: 'https://f493f79457eb36e16dbcea60b8972814@o1090422.ingest.sentry.io/4506551603298304',
    integrations: [
      new Sentry.BrowserTracing({
        // tracePropagationTargets'を設定して、どのURLに対して分散トレースを有効にするかを制御する。
        tracePropagationTargets: [
          'localhost',
          /^https:\/\/business-management\.conoc\.jp\//
        ]
      }),
      new Sentry.Replay({
        maskAllText: false,
        blockAllMedia: false
      })
    ],
    // この値は本番で調整するか、tracesSamplerを使用する
    // 詳細なコントロールはここに記載
    tracesSampleRate: 1.0,
    // tracePropagationTargets`を設定して、どのURLに対して分散トレースを有効にするかを制御する。
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/business-management\.conoc\.jp\//
    ],
    // 全セッションの10%にキャプチャー・リプレイを提供
    // エラーが発生したセッションの100
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  });
}

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
